import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { HawalasListWrapper } from './hawalas-list/HawalasList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const hawalasBreadcrumbs: Array<PageLink> = [
  {
    title: 'Hawala Management',
    path: '/admin/pages/hawalas',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/hawalas/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const HawalasPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='hawalas'
          index
          element={
            <>
              <PageTitle breadcrumbs={hawalasBreadcrumbs}>Hawalas list</PageTitle>
              <HawalasListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/hawalas/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/hawalas' />} />
    </Routes>
  )
}

export default HawalasPage
